import request from "@/router/axios";

export const getTrackGroupPage = (data) => {
  return request({
    url: "/api/produce/rtk-location/track/group/page",
    method: "post",
    data,
  });
};

export const getTrackPoints = (data) => {
  return request({
    url: "/api/produce/rtk-location/track/points",
    method: "post",
    data,
  });
};

export const getUserList = () => {
  return request({
    url: "/api/produce/blade-user/select/userList",
    method: "post",
    params: {},
  });
};
